import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v5h10V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 9v13h10V9H7z"
})), 'Battery80Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Battery80Sharp.js
// module id = 2266
// module chunks = 2